import React from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import ChatWidget from './ChatWidget';
import ChatPanel from '../Succession/Messaging/ChatPanel/ChatPanel';
import apolloClient from '../../lib/apolloClient';
import SuccessionThemeProvider from '../Succession/SuccessionThemeProvider';

const ChatWidgetWrapper = (props) => {
  // Check for modernization feature flag - features are stored as arrays
  const companyFeatures = get(props.company, 'features', []);
  const userFeatures = get(props.currentUser, 'features', []);
  
  // Check if modernization is enabled for company or user
  const useModernMessaging = companyFeatures.includes('findbob_modernization') || userFeatures.includes('findbob_modernization');
  
  if (useModernMessaging) {
    // For ChatPanel, wrap with ApolloProvider and SuccessionThemeProvider
    return (
      <ApolloProvider client={apolloClient}>
        <SuccessionThemeProvider company={props.company} user={props.currentUser}>
          <ChatPanel conversationId={props.room_id} currentUser={props.currentUser} />
        </SuccessionThemeProvider>
      </ApolloProvider>
    );
  }

  // Default to original ChatWidget
  return <ChatWidget {...props} />;
};

// Connect to Redux to get company data
const mapStateToProps = state => ({
  company: state.company,
});

export default connect(mapStateToProps)(ChatWidgetWrapper); 